
import React from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";


const FormCreateSize = ({ handleCreate }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    handleCreate(data);
  };

  return (
    <div className="container">
      <div className="size-form-container mx-auto">
        <h3 className="text-center fw-bold products-title ">
          Crear Nuevo Tamaño
        </h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Descripción del tamaño</label>
            <input
              type="text"
              className={`form-control ${errors.size_description ? "is-invalid" : ""}`}
              placeholder="Ejemplo: 1 medallón, 2 medallones etc."
              {...register("size_description", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.size_description?.message || ""}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Descripción corta del tamaño</label>
            <input
              type="text"
              className={`form-control ${errors.size_short_desc ? "is-invalid" : ""}`}
              placeholder="Ejemplo: S, M, L, XL, etc."
              {...register("size_short_desc", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.size_short_desc?.message || ""}
            </div>
          </div>

          <button type="submit" className="btn products-btn  w-100">
            Crear Tamaño
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormCreateSize;
